import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { setModerationConfig } from '@/lib/contentModeration';

let loaded = false;

/**
 * Lädt einmalig die Inhaltsfilter-Konfiguration aus der DB und übergibt sie
 * an den Moderation-Service. Sollte in App.tsx montiert werden.
 */
export function useContentModerationConfig() {
  useEffect(() => {
    if (loaded) return;
    loaded = true;

    (async () => {
      try {
        const { data, error } = await supabase
          .from('content_moderation_settings')
          .select('enabled, blocked_words')
          .order('updated_at', { ascending: false })
          .limit(1)
          .maybeSingle();
        if (error) return;
        if (!data) return;
        setModerationConfig({
          enabled: !!data.enabled,
          blockedWords: Array.isArray(data.blocked_words) ? data.blocked_words : null,
        });
      } catch {
        // ignore – fallback bleibt aktive Default-Liste
      }
    })();
  }, []);
}